import { createFeature, createReducer } from '@ngrx/store';

import { userPageSimilarCustomersReducers } from './user-page-similar-customers.reducer';
import { userPageSimilarCustomersInitialState } from './user-page-similar-customers.state';

export const userPageSimilarCustomersFeature = createFeature({
    name: 'userPageSimilarCustomers',
    reducer: createReducer(userPageSimilarCustomersInitialState, ...userPageSimilarCustomersReducers),
});
